export { LegalAndRegulatoryPage as default } from "@nvb/ui";
